module.exports = __webpack_public_path__ + "static/media/chapter-one-mountain.8233813e.png";